module.exports = __webpack_public_path__ + "static/media/20170620-_DSC067405.f29c70e4.jpg";